module.exports = fox._r("htmlplayer/images/acplayer-robot.png", __webpack_public_path__ + "_/_/_/_/common-components/htmlplayer/images/acplayer-robot.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/htmlplayer/images/acplayer-robot.png
// module id = 542
// module chunks = 4